"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var DownloadImportSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M5,10 L5,13 C5,13.5522847 5.44771525,14 6,14 L13,14 C13.5522847,14 14,13.5522847 14,13 L14,10 L15,10 L15,13 C15,14.1045695 14.1045695,15 13,15 L6,15 C4.8954305,15 4,14.1045695 4,13 L4,10 L5,10 Z M9,10.2948673 L9,3 L10,3 L10,10.2948673 L12.1583794,8.13843082 C12.3491834,7.94779864 12.6583984,7.94793788 12.8490306,8.13874181 C13.0424323,8.33484455 13.0417596,8.64649365 12.8497664,8.83950882 L9.5,12.2071068 L6.14153549,8.84138006 C5.94838366,8.64781056 5.94855292,8.33436304 6.1419137,8.14100226 C6.33526103,7.94765493 6.64869826,7.94752294 6.84220836,8.14070736 L9,10.2948673 Z" })));
};
DownloadImportSmall.displayName = 'DownloadImportSmall';
exports.default = DownloadImportSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=DownloadImportSmall.js.map